import actionTypes from './../constants/actionTypes';

const initialState = {
    listing: {},
    tag: {},
    saveResponse: {},
};
export const tagReducer = (state = initialState, action) => {
    try {
        const { type, payload, status } = action;
        switch (type) {
            case actionTypes.TAGS.LIST_TAGS: {
                return {
                    ...state,
                    listing: payload
                }
            }
            case actionTypes.TAGS.GET_TRACKING: {
                return {
                    ...state,
                    tag: payload
                }
            }
            case actionTypes.TAGS.SAVE_TRACKING: {
                return {
                    ...state,
                    saveResponse: payload
                }
            }
        }
        return state;
    } catch (error) {
        return state;
    }
}
export default tagReducer;
